import { Button, type ButtonTheme } from "@ui/Button";
import { Loader } from "@ui/Loader";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import { Show } from "solid-js";

function getSubmitButtonLabel(
	buttonLabel: string | undefined,
	variant: "default" | "reply",
	theme: "labs" | "studio",
	rounded?: boolean,
): string | undefined {
	if (rounded) {
		return "";
	}
	if (buttonLabel !== undefined) {
		return buttonLabel;
	}
	if (variant === "reply") {
		return "Ask";
	}
	if (theme === "studio") {
		return "Ask";
	}
	return "AskGVT";
}
type Props = {
	isLoading: boolean;
	requiresPoolSelection: boolean;
	/** All public pools, used to render the pool selector on the AskGVT home page. */
	publicPools?: { id: string; name: string }[];
	selectedPoolId: string;
	question: string;
	isDisabled: boolean;
	onSubmit: () => void;
	buttonLabel: string;
	buttonSymbol?: string;
	buttonTheme?: ButtonTheme;
	/** Keeps the button enabled with no question typed. */
	allowEmpty?: boolean;
	theme: "labs" | "studio";
	variant: "default" | "reply";
	rounded?: boolean;
};
export const AskQuestionSubmitButton = (props: Props) => {
	const hasSelectedPublicPool = () => {
		const id = props.selectedPoolId.trim();
		if (!id) {
			return false;
		}
		return (props.publicPools ?? []).some((pool) => pool.id === id);
	};
	const submitDisabled = () => {
		if (props.requiresPoolSelection && !hasSelectedPublicPool()) {
			return true;
		}
		if (props.isDisabled) {
			return true;
		}
		return !props.allowEmpty && props.question.trim().length === 0;
	};

	return (
		<Show
			when={!props.isLoading}
			fallback={
				<Button disabled={true} size="large">
					<Loader color="var(--white)" />
				</Button>
			}
		>
			{/* The tooltip only says what to fill in; a disabled box says why itself. */}
			<TooltipTrigger disabled={!submitDisabled() || props.isDisabled}>
				<Button
					onClick={() => props.onSubmit()}
					symbolPosition="after"
					theme={props.buttonTheme ?? "mint-grad"}
					size="large"
					symbol={
						props.buttonSymbol ??
						(props.rounded ? "chevron_right" : "arrow_forward")
					}
					disabled={submitDisabled()}
				>
					{getSubmitButtonLabel(
						props.buttonLabel,
						props.variant,
						props.theme,
						props.rounded,
					)}
				</Button>
				<Tooltip>
					<p>
						{props.requiresPoolSelection && !hasSelectedPublicPool()
							? "Please select a group"
							: "Please enter a question"}
					</p>
				</Tooltip>
			</TooltipTrigger>
		</Show>
	);
};
